import { useCallback } from 'react';
import { useTelegram } from '@/providers/TelegramProvider';

type Impact = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type Notify = 'success' | 'error' | 'warning';

/** Хук для тактильной отдачи Telegram. Безопасен вне Telegram (no-op). */
export function useHaptic(): {
  impact: (style?: Impact) => void;
  notify: (type: Notify) => void;
  selection: () => void;
} {
  const { webApp } = useTelegram();

  const impact = useCallback((style: Impact = 'light') => {
    webApp?.HapticFeedback.impactOccurred(style);
  }, [webApp]);

  const notify = useCallback((type: Notify) => {
    webApp?.HapticFeedback.notificationOccurred(type);
  }, [webApp]);

  const selection = useCallback(() => {
    webApp?.HapticFeedback.selectionChanged();
  }, [webApp]);

  return { impact, notify, selection };
}
